import { User } from "@/models/user.model"
import { type IUser } from "@/interfaces/api/user.interface"
import { UserRepository } from "@/repositories/user-repository"
import { ODataQueryBuilder } from "@/builder/odata-query-builder.ts"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export class UserController extends GenericModelController<User, IUser, UserRepository> {
  constructor() {
    super(User, {}, new UserRepository())
  }

  public async retrieveUserBySession(sessionUuid: string): Promise<User> {
    const query = new ODataQueryBuilder()
    query.eq("sessionUuid", sessionUuid)
    const users = await this.getList({ query })

    if (users.length === 0) {
      throw new Error("Could not retrieve user by session")
    }
    return users[0]
  }
}
